import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { AuthContext } from './FirebaseAuthProvider';
import { LoadingScreen } from '@app/components/LoadingScreen/LoadingScreen';

type OnlyPublicRouteProps = {
    path: string;
    exact?: boolean;
    redirectTo: string;
};

export const OnlyPublicRoute: React.FC<OnlyPublicRouteProps> = ({ path, exact, redirectTo, children }) => {
    const authStoreState = useContext(AuthContext);
    if (authStoreState.isAuthenticatingUser) {
        return <LoadingScreen />;
    }
    return (
        <Route
            exact={exact}
            path={path}
            render={() => (authStoreState.user ? <Redirect to={redirectTo} /> : children)}
        />
    );
};
